export const IDP_PROVIDERS = [
    {
        provider: 'okta',
        name: 'Okta',
        logoUrl: '/logo/okta.svg',
    },
    {
        provider: 'entra',
        name: 'Microsoft Entra ID',
        logoUrl: '/logo/microsoft-entra-id.svg',
    },
    {
        provider: 'custom',
        name: 'Custom OAuth2 / OIDC',
        logoUrl: '',
    }
] as const;

export const IDP_TYPES = ['okta', 'entra', 'custom'] as const;

export const getIdpProvider = (provider: string) => {
    return IDP_PROVIDERS.find(p => p.provider === provider);
};

export type IdpType = string;

export interface Idp {
    id: string;
    display_name: string;
    logo_url?: string;
    enabled: boolean;
    provider: IdpType;
    status?: number;
    tenant_id?: string;
    created_at?: string;
    updated_at?: string;
}

export interface IdpCreate {
    display_name: string;
    provider: IdpType;
    logo_url?: string;
    logo_data_url?: string;
    status?: number;
}

export interface IdpUpdate {
    display_name?: string;
    provider?: IdpType;
    logo_url?: string;
    logo_data_url?: string;
    status?: number;
}

export interface IdpHealthCheck {
    status: string;
    url?: string;
    http_status?: number;
    latency_ms?: number;
    message?: string;
}

export interface IdpAuthRate {
    successful: number;
    failed: number;
    total: number;
    success_rate: number;
    failure_rate: number;
}

export interface IdpConfigurationHealth {
    configuration_id: string;
    configuration_name: string;
    tenant_id?: string;
    tenant_name?: string;
    provider_type: string;
    metadata: IdpHealthCheck;
    jwks?: IdpHealthCheck;
}

export interface IdpHealthSummary {
    idp_id: string;
    overall_status: string;
    checked_at: string;
    last_successful_auth_at?: string;
    auth_24h: IdpAuthRate;
    configurations: IdpConfigurationHealth[];
}
